import {
  Event,
  EventRegistrationStatus,
  RecurringEventFrequency,
} from '@tribeplatform/gql-client/types'

import { CalendarProvider } from '../types.js'

export const hasRegisteredForEvent = (event: Event) => {
  return (
    event.authMemberProps?.eventRegistration?.status ===
    EventRegistrationStatus.registered
  )
}

export const isRecurringEvent = (event?: Event) => {
  if (!event) {
    return false
  }

  return (
    event.recurrenceConfig &&
    event.recurrenceConfig?.frequency !== RecurringEventFrequency.once
  )
}

export const getCalendarProviderIconHref = (provider: CalendarProvider) => {
  switch (provider) {
    case CalendarProvider.Google:
      return 'https://calendar.google.com/googlecalendar/images/favicons_2020q4/calendar_24.ico'
    case CalendarProvider.Outlook:
      return 'https://res.public.onecdn.static.microsoft/owamail/20250911063.07/resources/images/favicon-calendar.ico'
    case CalendarProvider.Apple:
      return 'https://www.apple.com/favicon.ico'
    default: {
      const _unknown: never = provider
      return _unknown
    }
  }
}
